import React from 'react';
import './PresenceFilterSection.css';

/**
 * Composant pour afficher les statistiques de présence avec un filtre par date
 */
const PresenceFilterSection = ({ 
  presenceDate, 
  onDateChange, 
  stats,
  loading = false 
}) => {
  const isToday = presenceDate === new Date().toISOString().slice(0, 10);
  
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('fr-FR', { 
      weekday: 'long', 
      day: 'numeric', 
      month: 'long', 
      year: 'numeric' 
    });
  };

  return (
    <div className="presence-filter-section">
      <div className="presence-header">
        <h3 className="section-title">📊 Présence du Personnel</h3>
        <div className="date-filter-container">
          <label htmlFor="presence-date-picker" className="date-label">
            📅 Filtrer par date :
          </label>
          <input
            id="presence-date-picker"
            type="date"
            value={presenceDate}
            onChange={(e) => onDateChange(e.target.value)}
            className="date-picker-input"
            max={new Date().toISOString().slice(0, 10)}
          />
          {isToday && <span className="today-badge">Aujourd'hui</span>}
        </div>
      </div>

      <div className="presence-date-display">
        {formatDate(presenceDate)}
      </div>

      {loading ? (
        <div className="loading-stats">
          <div className="spinner"></div>
          <span>Chargement des statistiques...</span>
        </div>
      ) : (
        <>
          <div className="total-employees-header">
            <span className="total-label">👥 Total employés :</span>
            <span className="total-value">{stats?.total_employees || 0}</span>
          </div>
          
          <div className="presence-stats-grid three-categories">
            <div className="stat-card on-time">
              <div className="stat-icon">✅</div>
              <div className="stat-content">
                <div className="stat-value">{stats?.employees_on_time || 0}</div>
                <div className="stat-label">À l'heure</div>
                <div className="stat-percentage">
                  {stats?.total_employees > 0
                    ? Math.round((stats.employees_on_time / stats.total_employees) * 100)
                    : 0}%
                </div>
              </div>
            </div>

            <div className="stat-card late">
              <div className="stat-icon">⏰</div>
              <div className="stat-content">
                <div className="stat-value">{stats?.retards || 0}</div>
                <div className="stat-label">En retard</div>
                <div className="stat-percentage">
                  {stats?.total_employees > 0
                    ? Math.round((stats.retards / stats.total_employees) * 100)
                    : 0}%
                </div>
              </div>
            </div>

            <div className="stat-card absent">
              <div className="stat-icon">❌</div>
              <div className="stat-content">
                <div className="stat-value">{stats?.employees_absent || 0}</div>
                <div className="stat-label">Absents</div>
                <div className="stat-percentage">
                  {stats?.total_employees > 0
                    ? Math.round((stats.employees_absent / stats.total_employees) * 100)
                    : 0}%
                </div>
              </div>
            </div>
          </div>
          
          <div className="presence-formula">
            <small>
              Formule : Absents = Total - (À l'heure + En retard) = {stats?.total_employees || 0} - ({stats?.employees_on_time || 0} + {stats?.retards || 0}) = {stats?.employees_absent || 0}
            </small>
          </div>
        </>
      )}

      {!isToday && !loading && (
        <div className="historical-note">
          ℹ️ Données historiques - Les informations proviennent des pointages enregistrés.
        </div>
      )}
    </div>
  );
};

export default PresenceFilterSection;
